import React from "react";
import { string, bool } from "prop-types";
import styled from "styled-components";

import DartyLogo from "@components/shared/Icons/Darty";
import FnacLogo from "@components/shared/Icons/FNAC";
import DartyFnacLogos from "@components/shared/Icons/FnacDarty";

import { getIsCountry, COUNTRIES } from "@lib/getIsCountry";
import { getStaticAssetURL } from "@lib/getStaticAssetURL";

const StyledFnacLogo = styled(FnacLogo)`
  padding: 5px;
`;

const FnacDartyIconContainer = ({ dataId, isOrientationHorizontal = true }) => {
  if (getIsCountry(COUNTRIES.IT)) {
    return (
      <img
        width={40}
        height={40}
        data-id={dataId}
        src={getStaticAssetURL(`/images/testDrive/Logo_W3.png`)}
      />
    );
  } else if (
    getIsCountry(COUNTRIES.ES) ||
    getIsCountry(COUNTRIES.BE) ||
    getIsCountry(COUNTRIES.PT)
  ) {
    return <FnacLogo width="40px" height="40px" data-id={dataId} />;
  } else if (isOrientationHorizontal) {
    return <DartyFnacLogos width="40px" height="100px" data-id={dataId} />;
  } else if (!isOrientationHorizontal) {
    return (
      <>
        <DartyLogo width="40px" height="40px" data-id={dataId} />
        <StyledFnacLogo width="40px" height="40px" data-id={dataId} />
      </>
    );
  }
};

FnacDartyIconContainer.propTypes = {
  dataId: string.isRequired,
  isOrientationHorizontal: bool,
};

export default FnacDartyIconContainer;
